import { Component, Vue } from 'vue-property-decorator';
import Tick from '@/assets/icons/tick-alt.svg?inline';

const InputCheckProps = Vue.extend({
  props: {
    label: { type: String, default: null },
    text: { type: String, default: null },
    subheading: { type: String, default: null },
    hyattPoints: { type: String, default: null },
    availability: { type: String, default: null },
    name: { type: String, default: '' },
    type: { type: String, default: 'checkbox' },
    value: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
    error: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    checked: { type: Boolean, default: false },
  },
});

@Component({
  components: {
    Tick,
  },
})
export default class InputCheck extends InputCheckProps {
  data() {
    return {
      isChecked: false,
      id: null,
      longRadio: false,
    };
  }

  mounted() {
    // console.error(
    //   'InputCheck.vue component is deprecated, please use CheckInput and RadioInput instead',
    // );

    this.$data.id = this.uuid;

    if (this.label && this.label.length >= 40) {
      this.$data.longRadio = true;
    }
  }

  change() {
    this.$emit('checked');
  }
}
